export default __webpack_public_path__ + "static/hw_vibration-a6b30c6464f003b24ddf234c2a61da10.jpg";